import React, { useState } from 'react';

const MonetizationGuide = () => {
  const [activeStep, setActiveStep] = useState(1);

  const steps = [
    {
      id: 1,
      title: "Configurar Suas Contas de Afiliados",
      description: "Primeiro passo essencial para começar a ganhar dinheiro",
      content: (
        <div className="space-y-6">
          <div className="bg-blue-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🎯 Programas Mais Lucrativos para Começar:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-white p-4 rounded-lg shadow">
                <h5 className="font-semibold text-green-600">1. ClickBank (Prioridade ALTA)</h5>
                <p className="text-sm text-gray-600 mb-2">Comissão: até 75% • Cookie: 60 dias</p>
                <ul className="text-sm space-y-1">
                  <li>• Produtos digitais de alto valor</li>
                  <li>• Comissões de $50-500 por venda</li>
                  <li>• Aprovação rápida</li>
                </ul>
                <a href="https://www.clickbank.com" target="_blank" rel="noopener noreferrer" 
                   className="inline-block mt-2 text-blue-600 hover:underline">
                  → Criar conta no ClickBank
                </a>
              </div>

              <div className="bg-white p-4 rounded-lg shadow">
                <h5 className="font-semibold text-orange-600">2. Amazon Associates</h5>
                <p className="text-sm text-gray-600 mb-2">Comissão: até 8% • Cookie: 24 horas</p>
                <ul className="text-sm space-y-1">
                  <li>• Milhões de produtos</li>
                  <li>• Alta taxa de conversão</li>
                  <li>• Marca confiável</li>
                </ul>
                <a href="https://affiliate-program.amazon.com" target="_blank" rel="noopener noreferrer" 
                   className="inline-block mt-2 text-blue-600 hover:underline">
                  → Criar conta na Amazon
                </a>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <h4 className="font-semibold mb-2">📋 Checklist de Configuração:</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <input type="checkbox" id="check1" className="mr-2" />
                <label htmlFor="check1">Criar conta no ClickBank (produtos digitais)</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" id="check2" className="mr-2" />
                <label htmlFor="check2">Criar conta na Amazon Associates</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" id="check3" className="mr-2" />
                <label htmlFor="check3">Anotar seus IDs de afiliado de cada programa</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" id="check4" className="mr-2" />
                <label htmlFor="check4">Configurar IDs no seu perfil da plataforma</label>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 2,
      title: "Encontrar Produtos Lucrativos",
      description: "Como identificar produtos que vendem e geram comissões altas",
      content: (
        <div className="space-y-6">
          <div className="bg-green-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🔍 Estratégia de Seleção de Produtos:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="bg-white p-4 rounded-lg">
                <h5 className="font-semibold text-green-600">Alta Comissão</h5>
                <p className="text-sm text-gray-600">Busque produtos com comissão mínima de $30-50 por venda</p>
              </div>
              <div className="bg-white p-4 rounded-lg">
                <h5 className="font-semibold text-blue-600">Baixa Concorrência</h5>
                <p className="text-sm text-gray-600">Nichos específicos têm menos competição</p>
              </div>
              <div className="bg-white p-4 rounded-lg">
                <h5 className="font-semibold text-purple-600">Alto Valor</h5>
                <p className="text-sm text-gray-600">Produtos de $200-2000 convertem melhor</p>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 3,
      title: "Criar Conteúdo que Converte",
      description: "Use a IA da plataforma para criar conteúdo que gera vendas",
      content: (
        <div className="space-y-6">
          <div className="bg-purple-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🤖 Estratégia de Conteúdo com IA:</h4>
            
            <div className="space-y-4">
              <div className="bg-white p-4 rounded-lg border-l-4 border-purple-500">
                <h5 className="font-semibold mb-2">1. Resenhas de Produtos (Mais Lucrativo)</h5>
                <p className="text-sm text-gray-600 mb-2">
                  Use o gerador de IA para criar resenhas detalhadas que respondem às principais dúvidas dos compradores.
                </p>
              </div>

              <div className="bg-white p-4 rounded-lg border-l-4 border-blue-500">
                <h5 className="font-semibold mb-2">2. Posts para Redes Sociais</h5>
                <p className="text-sm text-gray-600 mb-2">
                  Crie posts virais que direcionam tráfego para seus links de afiliado.
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 4,
      title: "Estratégias de Tráfego",
      description: "Como direcionar pessoas interessadas para seus links",
      content: (
        <div className="space-y-6">
          <div className="bg-orange-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🚀 Canais de Tráfego Mais Eficazes:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <h5 className="font-semibold text-orange-600">Tráfego Gratuito (Orgânico):</h5>
                
                <div className="bg-white p-4 rounded-lg">
                  <h6 className="font-semibold mb-2">1. YouTube (Mais Eficaz)</h6>
                  <ul className="text-sm space-y-1">
                    <li>• Vídeos de review e unboxing</li>
                    <li>• Tutoriais usando os produtos</li>
                    <li>• Lives interativas</li>
                  </ul>
                  <p className="text-xs text-gray-500 mt-2">Tempo para resultado: 2-6 meses</p>
                </div>

                <div className="bg-white p-4 rounded-lg">
                  <h6 className="font-semibold mb-2">2. Instagram/TikTok</h6>
                  <ul className="text-sm space-y-1">
                    <li>• Stories com produtos</li>
                    <li>• Reels comparando produtos</li>
                    <li>• Lives de perguntas e respostas</li>
                  </ul>
                  <p className="text-xs text-gray-500 mt-2">Tempo para resultado: 1-3 meses</p>
                </div>
              </div>

              <div className="space-y-4">
                <h5 className="font-semibold text-green-600">Tráfego Pago (Resultado Rápido):</h5>
                
                <div className="bg-white p-4 rounded-lg">
                  <h6 className="font-semibold mb-2">1. Google Ads</h6>
                  <ul className="text-sm space-y-1">
                    <li>• Palavras-chave de compra</li>
                    <li>• Landing pages otimizadas</li>
                    <li>• Orçamento: R$ 500-1000/mês</li>
                  </ul>
                  <p className="text-xs text-gray-500 mt-2">ROI esperado: 200-400%</p>
                </div>

                <div className="bg-white p-4 rounded-lg">
                  <h6 className="font-semibold mb-2">2. Facebook/Instagram Ads</h6>
                  <ul className="text-sm space-y-1">
                    <li>• Públicos interessados no produto</li>
                    <li>• Criativos de vídeo</li>
                    <li>• Orçamento: R$ 300-800/mês</li>
                  </ul>
                  <p className="text-xs text-gray-500 mt-2">ROI esperado: 150-300%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 5,
      title: "Monetizar a Plataforma (SaaS)",
      description: "Como ganhar dinheiro vendendo acesso à sua ferramenta",
      content: (
        <div className="space-y-6">
          <div className="bg-green-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">💰 Modelo de Negócio SaaS:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="bg-white p-4 rounded-lg text-center">
                <div className="text-2xl font-bold text-green-600">R$ 297/mês</div>
                <div className="text-sm text-gray-600">Plano Starter</div>
                <div className="text-xs text-gray-500 mt-1">100 usuários = R$ 9.700/mês</div>
              </div>
              <div className="bg-white p-4 rounded-lg text-center">
                <div className="text-2xl font-bold text-blue-600">R$ 797/mês</div>
                <div className="text-sm text-gray-600">Plano Pro</div>
                <div className="text-xs text-gray-500 mt-1">50 usuários = R$ 9.850/mês</div>
              </div>
              <div className="bg-white p-4 rounded-lg text-center">
                <div className="text-2xl font-bold text-purple-600">R$ 997/mês</div>
                <div className="text-sm text-gray-600">Plano Enterprise</div>
                <div className="text-xs text-gray-500 mt-1">20 usuários = R$ 9.940/mês</div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 6,
      title: "Automação de Redes Sociais",
      description: "Configure a automação para trabalhar 24/7 por você",
      content: (
        <div className="space-y-6">
          <div className="bg-purple-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">⚡ Automação em 8 Redes Sociais:</h4>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">📸</div>
                <h5 className="font-semibold text-pink-600">Instagram</h5>
                <p className="text-xs text-gray-600">Posts, Stories, Reels</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">📘</div>
                <h5 className="font-semibold text-blue-600">Facebook</h5>
                <p className="text-xs text-gray-600">Páginas, Grupos, Reels</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">▶️</div>
                <h5 className="font-semibold text-red-600">YouTube</h5>
                <p className="text-xs text-gray-600">Shorts, Vídeos</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">🎵</div>
                <h5 className="font-semibold text-gray-800">TikTok</h5>
                <p className="text-xs text-gray-600">Vídeos virais</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">🐦</div>
                <h5 className="font-semibold text-blue-400">Twitter/X</h5>
                <p className="text-xs text-gray-600">Tweets, Threads</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">📌</div>
                <h5 className="font-semibold text-red-500">Pinterest</h5>
                <p className="text-xs text-gray-600">Pins, Boards</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">💼</div>
                <h5 className="font-semibold text-blue-700">LinkedIn</h5>
                <p className="text-xs text-gray-600">Posts profissionais</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">💬</div>
                <h5 className="font-semibold text-green-600">WhatsApp</h5>
                <p className="text-xs text-gray-600">Status, Listas</p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <h4 className="font-semibold mb-2">📋 Checklist de Automação:</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar conta do Instagram Business</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar página do Facebook</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar canal do YouTube</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar conta do TikTok</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar Twitter/X</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar Pinterest</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Conectar LinkedIn</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Criar primeira campanha automática</label>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 7,
      title: "Marketing Internacional",
      description: "Expanda para 195+ países e multiplique seus ganhos",
      content: (
        <div className="space-y-6">
          <div className="bg-blue-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🌍 Mercados Mais Lucrativos:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">🇺🇸</div>
                <h5 className="font-semibold">Estados Unidos</h5>
                <p className="text-sm text-gray-600">Maior mercado do mundo</p>
                <p className="text-green-600 font-bold">$$$$ Alto ticket</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">🇬🇧</div>
                <h5 className="font-semibold">Reino Unido</h5>
                <p className="text-sm text-gray-600">Europa de alta renda</p>
                <p className="text-green-600 font-bold">$$$ Bom ticket</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl mb-2">🇩🇪</div>
                <h5 className="font-semibold">Alemanha</h5>
                <p className="text-sm text-gray-600">Economia forte</p>
                <p className="text-green-600 font-bold">$$$ Bom ticket</p>
              </div>
            </div>

            <div className="bg-green-100 p-4 rounded-lg">
              <h5 className="font-semibold text-green-800 mb-2">💡 Dica: IA Multilíngue</h5>
              <p className="text-sm text-green-700">
                Use o gerador de conteúdo IA para criar posts em inglês, espanhol, francês, 
                alemão e italiano automaticamente!
              </p>
            </div>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <h4 className="font-semibold mb-2">📋 Checklist Internacional:</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Criar conta Amazon Associates EUA</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Gerar conteúdo em inglês com IA</label>
              </li>
              <li className="flex items-center">
                <input type="checkbox" className="mr-2" />
                <label>Configurar links para mercado internacional</label>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 8,
      title: "Escalar e Multiplicar Resultados",
      description: "Estratégias avançadas para maximizar seus lucros",
      content: (
        <div className="space-y-6">
          <div className="bg-gradient-to-r from-green-50 to-blue-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🚀 Estratégia de Escala:</h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-4 rounded-lg shadow">
                <h5 className="font-semibold text-green-600 mb-3">📈 Aumentar Volume</h5>
                <ul className="text-sm space-y-2">
                  <li>✅ Criar mais links (meta: 100/mês)</li>
                  <li>✅ Postar em mais plataformas</li>
                  <li>✅ Usar automação 24/7</li>
                  <li>✅ Testar novos nichos</li>
                </ul>
              </div>
              <div className="bg-white p-4 rounded-lg shadow">
                <h5 className="font-semibold text-blue-600 mb-3">💰 Aumentar Ticket</h5>
                <ul className="text-sm space-y-2">
                  <li>✅ Promover produtos de alto valor</li>
                  <li>✅ Focar em mercados internacionais</li>
                  <li>✅ Vender plano Enterprise do SaaS</li>
                  <li>✅ Upsell para clientes existentes</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-purple-50 p-6 rounded-lg">
            <h4 className="font-bold text-lg mb-4">🎯 Meta de Renda Mensal:</h4>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-white p-3 rounded-lg text-center">
                <div className="text-sm text-gray-500">Mês 1</div>
                <div className="text-xl font-bold text-green-600">R$ 1.000</div>
              </div>
              <div className="bg-white p-3 rounded-lg text-center">
                <div className="text-sm text-gray-500">Mês 3</div>
                <div className="text-xl font-bold text-green-600">R$ 5.000</div>
              </div>
              <div className="bg-white p-3 rounded-lg text-center">
                <div className="text-sm text-gray-500">Mês 6</div>
                <div className="text-xl font-bold text-green-600">R$ 15.000</div>
              </div>
              <div className="bg-white p-3 rounded-lg text-center">
                <div className="text-sm text-gray-500">Mês 12</div>
                <div className="text-xl font-bold text-green-600">R$ 50.000+</div>
              </div>
            </div>
          </div>

          <div className="bg-green-100 p-6 rounded-lg text-center">
            <h4 className="font-bold text-xl text-green-800 mb-2">🎉 Parabéns!</h4>
            <p className="text-green-700">
              Você completou o guia! Agora é hora de colocar em prática. 
              Comece pelo Passo 1 e siga consistentemente. Os resultados virão!
            </p>
            <a 
              href="/setup" 
              className="inline-block mt-4 bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700"
            >
              🚀 Começar Agora - Configurar APIs
            </a>
          </div>
        </div>
      )
    }
  ];

  const handleStepClick = (stepId) => {
    setActiveStep(stepId);
  };

  const currentStep = steps.find(step => step.id === activeStep);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          💰 Guia Completo para Ganhar Dinheiro Real
        </h1>
        <p className="text-xl text-gray-600">
          Roteiro passo a passo para transformar sua ferramenta em uma máquina de lucro
        </p>
      </div>

      {/* Progress Bar */}
      <div className="mb-8">
        <div className="flex items-center justify-between mb-2">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold cursor-pointer transition-colors ${
                  activeStep >= step.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}
                onClick={() => handleStepClick(step.id)}
              >
                {step.id}
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`w-24 h-1 mx-2 transition-colors ${
                    activeStep > step.id ? 'bg-blue-600' : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="text-center text-sm text-gray-600">
          Passo {activeStep} de {steps.length}
        </div>
      </div>

      {/* Current Step Content */}
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {currentStep?.title}
          </h2>
          <p className="text-gray-600">
            {currentStep?.description}
          </p>
        </div>

        {currentStep?.content}

        {/* Navigation */}
        <div className="flex justify-between mt-8 pt-6 border-t">
          <button
            onClick={() => setActiveStep(Math.max(1, activeStep - 1))}
            disabled={activeStep === 1}
            className="px-6 py-2 border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            ← Passo Anterior
          </button>
          
          <button
            onClick={() => setActiveStep(Math.min(steps.length, activeStep + 1))}
            disabled={activeStep === steps.length}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Próximo Passo →
          </button>
        </div>
      </div>
    </div>
  );
};

export default MonetizationGuide;